import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import { useNavigate } from 'react-router-dom';
import AppLayout from '../../layout/app.layout';
import Counters from '../../components/reports/counters.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';
import Loading from '../../components/table-elements/loading.component';

const DashboardView = () => {
  const pageTitle = PAGE_TITLE_LIST.OVERVIEW_DASHBOARD;

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <>
      {loading && <Loading />}

      {!loading && (
        <AppLayout pageTitle={pageTitle}>
          <Counters />
        </AppLayout>
      )}
    </>
  );
};

export default DashboardView;
